class LqdFancyImageHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initInteractiveSwap();
    this.initHover3d();
    this.initReveal();
    this.initInView();

  }

  getDefaultSettings() {
    return {
      isotopeData: null,
      selectors: {
        interactiveSwapElement: '[data-lqd-interactive-swap]',
        hover3dElement: '[data-hover3d]',
        revealElement: '[data-reveal]',
        inViewElement: '[data-inview]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $interactiveSwapElement: this.$element.find(selectors.interactiveSwapElement),
      $hover3dElement: this.$element.find(selectors.hover3dElement),
      $revealElement: this.$element.find(selectors.revealElement),
      $inViewElement: this.$element.find(selectors.inViewElement),
    }
  }

  initInteractiveSwap() {

    setTimeout(() => {
      this.elements.$interactiveSwapElement.liquidInteractiveSwap();
    }, 500)

  }

  initHover3d() {

    this.elements.$hover3dElement.liquidHover3d();

  }

  initReveal() {

    this.elements.$revealElement.liquidReveal();

  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleHover3dDestroy();

  }

  handleHover3dDestroy() {

    if ( ! this.elements.$hover3dElement.length ) return;

    const hover3dData = this.elements.$hover3dElement.data('plugin_liquidHover3d');

    if ( hover3dData ) {
      hover3dData.destroy();
    }

  }

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFancyImageHandler, { $element } );
};